export default () => ({
  root: {
    width: '100%',
  },
  error: {
    marginBottom: 12,
  },
});
